import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import EngineScoringTestHeaderComponent from './EngineScoringTestHeaderComponent';
import EngineScoringTestListComponent from './EngineScoringTestListComponent';
import { Pagination, Card, FakeText } from '@totalsoft/rocket-ui';
import { FilterFrames } from '@mui/icons-material';
import { Grid } from '@mui/material';

const EngineScoringTestComponent = ({
  scoringTestAttributes,
  paginationAndFilter,
  rowsPerPageOptions,
  onRowsPerPageChange,
  onPageChange,
  onRefresh,
  onFilterValueChanged,
  scoringTestResponse
}) => {
  const { t } = useTranslation();
  return (
    <Card icon={FilterFrames} iconColor='primary' title={t('EngineScoring.Test.Title')}>
      {scoringTestResponse === undefined || scoringTestResponse === null ? (
        <FakeText lines={10} />
      ) : (
        <Grid container spacing={1}>
          <EngineScoringTestHeaderComponent
            scoringTestScore={scoringTestResponse}
            onFilterValueChanged={onFilterValueChanged}
            fullTextFilter={paginationAndFilter.filter}
            onRefresh={onRefresh}
          />
          <EngineScoringTestListComponent scoringTestAttributes={scoringTestAttributes} />
          <Grid item xs={12}>
            <Pagination
              loading={false}
              count={paginationAndFilter.totalCount}
              pageSize={paginationAndFilter.pageSize}
              page={paginationAndFilter.page}
              rowsPerPageOptions={rowsPerPageOptions}
              onRowsPerPageChange={onRowsPerPageChange}
              onPageChange={onPageChange}
              onRefresh={onRefresh}
            />
          </Grid>
        </Grid>
      )}
    </Card>
  );
};

EngineScoringTestComponent.propTypes = {
  scoringTestAttributes: PropTypes.array.isRequired,
  paginationAndFilter: PropTypes.object.isRequired,
  onPageChange: PropTypes.func,
  onRowsPerPageChange: PropTypes.func,
  onRefresh: PropTypes.func,
  rowsPerPageOptions: PropTypes.array,
  onFilterValueChanged: PropTypes.func.isRequired,
  scoringTestResponse: PropTypes.number
};

export default EngineScoringTestComponent;
